import { render, staticRenderFns } from "./WpAdminDetails.vue?vue&type=template&id=1b1e2777&"
import script from "./WpAdminDetails.vue?vue&type=script&lang=js&"
export * from "./WpAdminDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports